var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.filteredItems, function(item) {
      return _c(
        "div",
        {
          key: _vm.query + "/" + item.id + "/" + item.level,
          staticClass: "item",
          class: "level" + (_vm.query ? "1" : item.level)
        },
        [
          _c(
            "span",
            {
              staticClass: "name",
              class: { changed: item.modifiedCount },
              on: {
                click: function($event) {
                  return _vm.toggle(item.id)
                }
              }
            },
            [
              _c("b-icon", {
                class: "level" + (_vm.query ? "1" : item.level),
                attrs: {
                  icon:
                    _vm.expanded.indexOf(item.id) === -1
                      ? "folder"
                      : "folder-open",
                  pack: "fas",
                  size: "is-small"
                }
              }),
              _vm._v("\n      " + _vm._s(item.name) + "\n      "),
              item.documentsTotal > 0
                ? [
                    _c("span", {
                      staticClass: "tag is-rounded is-small",
                      domProps: { textContent: _vm._s(item.documentsTotal) }
                    }),
                    item.documentsTotal - item.documentsReadCount > 0
                      ? _c("span", {
                          staticClass: "tag is-rounded is-primary",
                          domProps: {
                            textContent: _vm._s(
                              item.documentsTotal - item.documentsReadCount
                            )
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              item.details === false
                ? _c("b-icon", {
                    attrs: {
                      icon: "spinner",
                      "custom-class": "fa-spin",
                      size: "is-small"
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expanded.indexOf(item.id) !== -1,
                  expression: "expanded.indexOf(item.id) !== -1"
                }
              ]
            },
            [
              item.documents.length > 0
                ? _c("PortefeuilleArboDocs", {
                    attrs: {
                      id: item.id,
                      level: item.level,
                      documents: item.documents
                    }
                  })
                : _vm._e(),
              item.collections.length > 0
                ? _c("PortefeuilleArboCollections", {
                    attrs: {
                      id: item.id,
                      level: item.level,
                      collections: item.collections
                    }
                  })
                : _vm._e(),
              !_vm.query
                ? _c("PortefeuilleArbo", {
                    ref: "arbo",
                    refInFor: true,
                    attrs: {
                      items: _vm.items,
                      level: item.level + 1,
                      parent: item.id,
                      query: _vm.query,
                      showUnreadOnly: _vm.showUnread
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }